module.exports = __webpack_public_path__ + "media/tuning.d76eb79c.mp4";